/**
 * Hide Shopify Inbox / Chat bubble while the mobile menu drawer is open.
 */
(function () {
  var DRAWER_ID = 'header-sidebar-menu';
  var HIDDEN_CLASS = 'outpatch-menu-open-hide-chat';
  var CHAT_SELECTORS = [
    '#shopify-element-wrapper',
    'shopify-chat',
    '#ShopifyChat',
    '#shopify-chat',
    '[id*="ShopifyChat"]',
    'iframe[title*="Chat" i]',
    'iframe[id*="chat" i]'
  ];

  function drawer() {
    return document.getElementById(DRAWER_ID);
  }

  function isDrawerOpen() {
    var el = drawer();
    return !!(el && el.hasAttribute('open'));
  }

  function setChatHidden(hidden) {
    document.documentElement.classList.toggle(HIDDEN_CLASS, hidden);
    document.body.classList.toggle(HIDDEN_CLASS, hidden);

    CHAT_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (hidden) {
          node.setAttribute('data-outpatch-hidden-by-menu', 'true');
          node.style.setProperty('display', 'none', 'important');
          node.style.setProperty('visibility', 'hidden', 'important');
          node.style.setProperty('pointer-events', 'none', 'important');
        } else if (node.getAttribute('data-outpatch-hidden-by-menu') === 'true') {
          node.removeAttribute('data-outpatch-hidden-by-menu');
          node.style.removeProperty('display');
          node.style.removeProperty('visibility');
          node.style.removeProperty('pointer-events');
        }
      });
    });

    // Shadow-root host for Inbox (button uses part="activator")
    document.querySelectorAll('shopify-chat').forEach(function (host) {
      if (!host.shadowRoot) return;
      var activator = host.shadowRoot.querySelector('#shopify-element-wrapper, .activator, [part="activator"]');
      if (!activator) return;
      if (hidden) {
        activator.style.setProperty('display', 'none', 'important');
      } else {
        activator.style.removeProperty('display');
      }
    });
  }

  function sync() {
    setChatHidden(isDrawerOpen());
  }

  function watchDrawer(el) {
    if (!el || el.__outpatchChatHideBound) return;
    el.__outpatchChatHideBound = true;
    new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['open'] });
    el.addEventListener('dialog:after-show', sync);
    el.addEventListener('dialog:after-hide', sync);
  }

  function init() {
    watchDrawer(drawer());
    sync();

    // Chat widget often injects late
    new MutationObserver(function () {
      watchDrawer(drawer());
      sync();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
